import PropTypes from "prop-types";
import {
  DISPUTE_STATUS,
  DISPUTE_STATUS_LABELS,
} from "../../constants/disputes";
import "./DisputeStatusPill.css";

const STATUS_CLASS = {
  [DISPUTE_STATUS.UNDER_REVIEW]: "dispute-status--under-review",
  [DISPUTE_STATUS.DECLINED]: "dispute-status--declined",
  [DISPUTE_STATUS.SETTLED]: "dispute-status--settled",
  [DISPUTE_STATUS.WITHDRAWN]: "dispute-status--withdrawn",
};

const DisputeStatusPill = ({ status }) => {
  if (!status) return null;

  const className = STATUS_CLASS[status] || "";
  const label = DISPUTE_STATUS_LABELS[status] || status;

  return <span className={`dispute-status-pill ${className}`}>{label}</span>;
};

DisputeStatusPill.propTypes = {
  status: PropTypes.oneOf(Object.values(DISPUTE_STATUS)),
};

export default DisputeStatusPill;
